import { render, staticRenderFns } from "./TreatmentForm.vue?vue&type=template&id=7f678288&scoped=true"
import script from "./TreatmentForm.vue?vue&type=script&lang=js"
export * from "./TreatmentForm.vue?vue&type=script&lang=js"
import style0 from "./TreatmentForm.vue?vue&type=style&index=0&id=7f678288&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f678288",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f678288')) {
      api.createRecord('7f678288', component.options)
    } else {
      api.reload('7f678288', component.options)
    }
    module.hot.accept("./TreatmentForm.vue?vue&type=template&id=7f678288&scoped=true", function () {
      api.rerender('7f678288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/TreatmentForm.vue"
export default component.exports